'use strict';

import VideoDeskUIController from './VideoDeskUIController';

let videoDeskInstance;

export function create() {
  // Can only have one instance of the video desk functionality
  if (videoDeskInstance) {
    return;
  }

  // If the required configuration is output
  if (window.videoChatEngineers) {
    videoDeskInstance = new VideoDeskUIController(window.videoChatEngineers);
  }
}




// WEBPACK FOOTER //
// ./assets/components/VideoDesk/VideoDesk.js